import { 
    Grid, 
    Tab, 
    Table, 
    TableBody, 
    TableCell, 
    TableContainer, 
    TableHead,
    TableRow, 
    Tabs 
} from "@mui/material";

import { useState } from "react";

import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";

function ArtifactsTab() {
    const latinDescriptionFiller = "Lorem ipsum odor amet, consectetuer adipiscing elit. Rhoncus vivamus convallis mollis sociosqu quisque praesent eget. Imperdiet iaculis nulla nisl aenean auctor leo. Gravida placerat hendrerit lacinia parturient aptent hendrerit. Habitant porta vehicula nullam conubia mattis id?"
    const dummyMissionNeeds = [
        {
            title: "Mission need 1",
            description: latinDescriptionFiller
        },
        {
            title: "Mission need 2",
            description: latinDescriptionFiller
        },
        {
            title: "Mission need 3",
            description: latinDescriptionFiller
        },
        {
            title: "Mission need 4",
            description: latinDescriptionFiller
        },
    ]

    const dummyConOps = [
        {
            title: "ConOp 1",
            description: latinDescriptionFiller
        },
        {
            title: "ConOp 2",
            description: latinDescriptionFiller
        },
        {
            title: "ConOp 3",
            description: latinDescriptionFiller
        },
        {
            title: "ConOp 4",
            description: latinDescriptionFiller
        },
    ]

    const dummyCapabilities = [
        {
            title: "Capability 1",
            description: latinDescriptionFiller
        },
        {
            title: "Capability 2",
            description: latinDescriptionFiller
        },
        {
            title: "Capability 3",
            description: latinDescriptionFiller
        },
        {
            title: "Capability 4",
            description: latinDescriptionFiller
        },
    ]

    const dummyRequirements = [
        {
            title: "Requirement 1",
            description: latinDescriptionFiller
        },
        {
            title: "Requirement 2",
            description: latinDescriptionFiller
        },
        {
            title: "Requirement 3",
            description: latinDescriptionFiller
        },
        {
            title: "Requirement 4",
            description: latinDescriptionFiller
        },
    ]

    const dummyArtifacts = [
        {
            title: "Artifact 1",
            description: latinDescriptionFiller
        },
        {
            title: "Artifact 2",
            description: latinDescriptionFiller
        },
        {
            title: "Artifact 3",
            description: latinDescriptionFiller
        },
        {
            title: "Artifact 4",
            description: latinDescriptionFiller
        },
    ]

    const [selectedTopIndex, updateSelectedTopIndex] = useState(0)
    const [selectedInnerIndex, updateSelectedInnerIndex] = useState(0)
    return (
        <Grid container>
            <MDBox pt={1} bgColor="grey-100">
                <MDBox display="flex">
                    <Tabs
                        value={selectedTopIndex}
                        onChange={(_, index) => updateSelectedTopIndex(index)}
                    >
                        <Tab label="Decomposed Objects"/>
                        <Tab label="Ingested Artifacts"/>
                    </Tabs>
                </MDBox>
                
                {/* Decomposed Objects Tab */}
                {selectedTopIndex === 0 && (
                    <MDBox bgColor="grey-300">
                        <Grid container spacing={1}>
                            <Grid item lg={12}>
                                <MDBox bgColor="grey-300" sx={{borderBottom: 2, borderBottomColor: "#D4E2F1"}}>
                                    <MDTypography variant="body2">Some description</MDTypography>
                                </MDBox>
                            </Grid>

                            <Grid item lg={12}>
                                <MDBox bgColor="grey-100" pt={1}>
                                    <MDBox display="flex">
                                        <Tabs
                                            value={selectedInnerIndex}
                                            onChange={(_, index) => updateSelectedInnerIndex(index)}
                                        >
                                            <Tab label="Mission Needs"/>
                                            <Tab label="ConOps"/>
                                            <Tab label="Capabilities"/>
                                            <Tab label="Requirements"/>
                                        </Tabs>
                                    </MDBox>

                                    {selectedInnerIndex === 0 && (
                                        <MDBox p={1} bgColor="grey-300">
                                            <Grid container spacing={1}>
                                                <Grid item lg={12}>
                                                    <MDBox bgColor="grey-300" sx={{borderBottom: 2, borderBottomColor: "#D4E2F1"}}>
                                                        <MDTypography variant="body2">These are mission needs</MDTypography>
                                                    </MDBox>
                                                </Grid>

                                                <Grid item lg={12}>
                                                    <TableContainer sx={{maxHeight: "calc(100vh * .45)"}}>
                                                        <Table stickyHeader>
                                                            <TableHead sx={{ display: "table-header-group" }}>
                                                                <TableRow>
                                                                    <TableCell>Title</TableCell>
                                                                    <TableCell>Description</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {dummyMissionNeeds.map((row, index) => (
                                                                    <TableRow key={index}>
                                                                        <TableCell>{row.title}</TableCell>
                                                                        <TableCell>{row.description}</TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Grid>
                                            </Grid>
                                        </MDBox>
                                    )}

                                    {selectedInnerIndex === 1 && (
                                        <MDBox p={1} bgColor="grey-300">
                                            <Grid container spacing={1}>
                                                <Grid item lg={12}>
                                                    <MDBox bgColor="grey-300" sx={{borderBottom: 2, borderBottomColor: "#D4E2F1"}}>
                                                        <MDTypography variant="body2">These are the ConOps</MDTypography>
                                                    </MDBox>
                                                </Grid>

                                                <Grid item lg={12}>
                                                    <TableContainer sx={{maxHeight: "calc(100vh * .45)"}}>
                                                        <Table stickyHeader>
                                                            <TableHead sx={{ display: "table-header-group" }}>
                                                                <TableRow>
                                                                    <TableCell>Title</TableCell>
                                                                    <TableCell>Description</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {dummyConOps.map((row, index) => (
                                                                    <TableRow key={index}>
                                                                        <TableCell>{row.title}</TableCell>
                                                                        <TableCell>{row.description}</TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Grid>
                                            </Grid>
                                        </MDBox>
                                    )}

                                    {selectedInnerIndex === 2 && (
                                        <MDBox p={1} bgColor="grey-300">
                                            <Grid container spacing={1}>
                                                <Grid item lg={12}>
                                                    <MDBox bgColor="grey-300" sx={{borderBottom: 2, borderBottomColor: "#D4E2F1"}}>
                                                        <MDTypography variant="body2">These are the capabilities</MDTypography>
                                                    </MDBox>
                                                </Grid>

                                                <Grid item lg={12}>
                                                    <TableContainer sx={{maxHeight: "calc(100vh * .45)"}}>
                                                        <Table stickyHeader>
                                                            <TableHead sx={{ display: "table-header-group" }}>
                                                                <TableRow>
                                                                    <TableCell>Title</TableCell>
                                                                    <TableCell>Description</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {dummyCapabilities.map((row, index) => (
                                                                    <TableRow key={index}>
                                                                        <TableCell>{row.title}</TableCell>
                                                                        <TableCell>{row.description}</TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Grid>
                                            </Grid>
                                        </MDBox>
                                    )}

                                    {selectedInnerIndex === 3 && (
                                        <MDBox p={1} bgColor="grey-300">
                                            <Grid container spacing={1}>
                                                <Grid item lg={12}>
                                                    <MDBox bgColor="grey-300" sx={{borderBottom: 2, borderBottomColor: "#D4E2F1"}}>
                                                        <MDTypography variant="body2">These are the requirements</MDTypography>
                                                    </MDBox>
                                                </Grid>

                                                <Grid item lg={12}>
                                                    <TableContainer sx={{maxHeight: "calc(100vh * .45)"}}>
                                                        <Table stickyHeader>
                                                            <TableHead sx={{ display: "table-header-group" }}>
                                                                <TableRow>
                                                                    <TableCell>Title</TableCell>
                                                                    <TableCell>Description</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {dummyRequirements.map((row, index) => (
                                                                    <TableRow key={index}>
                                                                        <TableCell>{row.title}</TableCell>
                                                                        <TableCell>{row.description}</TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Grid>
                                            </Grid>
                                        </MDBox>
                                    )}
                                </MDBox>
                            </Grid>
                        </Grid>
                    </MDBox>
                )}

                {/* Ingested Artifacts Tab */}
                {selectedTopIndex === 1 && (
                    <Grid container spacing={2}>
                        <Grid item lg={12}>
                            <MDBox bgColor="grey-300" sx={{borderBottom: 2, borderBottomColor: "#D4E2F1"}}>
                                <MDTypography variant="body2">Some description</MDTypography>
                            </MDBox>
                        </Grid>

                        <Grid item lg={12}>
                            <TableContainer sx={{maxHeight: "calc(100vh * .54)"}}>
                                <Table stickyHeader>
                                    <TableHead sx={{ display: "table-header-group" }}>
                                        <TableRow>
                                            <TableCell>Title</TableCell>
                                            <TableCell>Description</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {dummyArtifacts.map((row, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{row.title}</TableCell>
                                                <TableCell>{row.description}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                )}

            </MDBox>
        </Grid>
    )
}

export default ArtifactsTab;